<template>
    <span :class="{'edit_textarea': element == 'textarea'}">
      <span class="edited_content" v-if="!editmode" v-html="editable" @click.prevent="editmode = true">
      </span>
      <!--button v-if="!editmode" class="edit_icon" @click.prevent="editmode = true"><span class="material-icons ico">create</span></button-->
      <span class="edit_field" v-if="editmode">
        <form id="edit_pagetext" method="post" @submit.prevent="saveText()">
          <input v-if="element == 'normal'" class="textinput" type="text" v-model="editable" autofocus/>
          <textarea v-if="element == 'textarea'" class="textinput" type="text" v-model="editable" autofocus></textarea>
          <button class="btn btn-primary">Opslaan</button>
        </form>
      </span>
    </span>
</template>

<script>  

import { userService } from '../../services/user.service.js';
import { authHeader } from '../../services/auth-header.js';

import axios from 'axios';

export default {
  props: {
    editable: String,
    pageid: String,
    dbentry: String,
    element: String
  },
  data: function(){
    return{
      editmode: false
    }
  },
  methods: {
    saveText(){

      const requestOptions = {
        headers: authHeader()
      }

      if(this.pageid){
          // is a page field
          const data = {
            websiteid: this.$route.params.websiteid,
            pageid: this.pageid,
            dbentry: this.dbentry,
            content: this.editable
          }

          axios.patch(process.env.VUE_APP_ROOT_API+'/pages/', data, requestOptions)
          .then(response => {
              this.editmode = false
          })
      } else {
          // is a setting field
          const data = {
              websiteid: this.$route.params.websiteid,
              dbentry: this.dbentry,
              content: this.editable
          }

          axios.patch(process.env.VUE_APP_ROOT_API+'/settings/', data, requestOptions)
          .then(response => {
              this.editmode = false
          })
      }

    },
  }
}
</script>
